import { FormGroup, FormArray } from "@angular/forms";
import { BaseViewModel } from "./base.view-model";
import { ViewModelModelMappingService } from "../../core/services/view-model-model-mapping.service";

export abstract class BaseFormViewModel extends BaseViewModel {
    
    abstract toFormGroup?(existingFormGroup?: FormGroup): FormGroup;

    static fromFormModel(formModel: any): any {
        throw "Must be implemented by dervied BaseFormViewModel"
    }

    static clearFormArray(formArray: FormArray) {
        if(!formArray) {
            return;
        }
        
        while (0 !== formArray.length) {
            formArray.removeAt(0);
        }
    }
}